import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LuCompass } from "react-icons/lu";
import { selectIsHeadingUp, setIsHeadingUp } from '../mapSlice';

const CompassControl = ({ bearing, isDrivingMode }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isHeadingUp = useSelector(selectIsHeadingUp);

    // Only show in driving mode (or if we want to allow pre-emptive toggle)
    // Per plan: "IsDrivingMode && IsHeadingUp" logic implies it's most useful there.
    // Let's hide it if not driving to keep UI clean, or maybe show it but disabled?
    // Let's show it only in driving mode for now as per "Control Stack" placement.
    if (!isDrivingMode) return null;

    const handleClick = (e) => {
        e.preventDefault();
        dispatch(setIsHeadingUp(!isHeadingUp));
    };

    const title = isHeadingUp ? t('map.north_up', 'Switch to North Up') : t('map.heading_up', 'Switch to Heading Up');

    // Rotation logic for the icon
    // If Map is Heading Up (Rotated -Bearing):
    // - North is at Angle +Bearing relative to "Up".
    // - So Compass Needle should point at +Bearing.
    // If Map is North Up:
    // - North is Up (0).
    // - Compass Needle should point Up (0).

    const rotation = isHeadingUp ? bearing : 0;

    return (
        <a
            href="#"
            className="leaflet-bar-part leaflet-bar-part-single"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '30px',
                height: '30px',
                textDecoration: 'none',
                color: 'black',
                cursor: 'pointer'
            }}
            title={title}
            onClick={handleClick}
        >
            <LuCompass
                size="18px" // Standard icon size roughly
                style={{
                    transform: `rotate(${rotation}deg)`,
                    transition: 'transform 0.3s ease',
                    color: isHeadingUp ? '#007bff' : '#333'
                }}
            />
        </a>
    );
};

export default CompassControl;
